(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-fitment-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vehicle-filter]').forEach((section) => {
    const yearSelect = section.querySelector('[data-fitment-year]');
    const makeSelect = section.querySelector('[data-fitment-make]');
    const modelSelect = section.querySelector('[data-fitment-model]');
    const universalToggle = section.querySelector('[data-fitment-universal]');
    const resetButton = section.querySelector('[data-fitment-reset]');
    const countElement = section.querySelector('[data-fitment-count]');
    const emptyElement = section.querySelector('[data-fitment-empty]');
    const previousButton = section.querySelector('[data-fitment-previous]');
    const nextButton = section.querySelector('[data-fitment-next]');
    const pageElement = section.querySelector('[data-fitment-page]');
    const cards = Array.from(section.querySelectorAll('[data-vehicle-product]'));
    const pageSize = 24;
    let currentPage = 1;

    const products = cards.map((card) => {
      let records = [];
      try {
        records = JSON.parse(card.dataset.fitment || '[]');
      } catch (error) {
        records = [];
      }
      return {
        card,
        universal: card.dataset.universal === 'true',
        records: records.map((record) => {
          const values = record.split('|');
          return {
            make: values[0] || '',
            model: values[1] || '',
            start: Number(values[2]) || null,
            end: Number(values[3]) || null
          };
        })
      };
    });

    const specificRecords = products.flatMap((product) => product.records).filter((record) => record.make !== 'Universal');

    const replaceOptions = (select, placeholder, values) => {
      const currentValue = select.value;
      select.replaceChildren(new Option(placeholder, ''));
      values.forEach((value) => select.add(new Option(value, value)));
      if (values.includes(currentValue)) select.value = currentValue;
    };

    const matchesYear = (record, year) => {
      if (!year) return true;
      if (!record.start || !record.end) return true;
      const numericYear = Number(year);
      return numericYear >= record.start && numericYear <= record.end;
    };

    const updateMakeOptions = () => {
      const year = yearSelect.value;
      const values = [...new Set(specificRecords.filter((record) => matchesYear(record, year)).map((record) => record.make))].sort();
      replaceOptions(makeSelect, makeSelect.options[0].text, values);
      makeSelect.disabled = !year;
      if (makeSelect.disabled) makeSelect.value = '';
    };

    const updateModelOptions = () => {
      const year = yearSelect.value;
      const make = makeSelect.value;
      const values = [...new Set(specificRecords.filter((record) => matchesYear(record, year) && record.make === make).map((record) => record.model))].sort();
      replaceOptions(modelSelect, modelSelect.options[0].text, values);
      modelSelect.disabled = !make;
      if (modelSelect.disabled) modelSelect.value = '';
    };

    const productMatches = (product) => {
      const year = yearSelect.value;
      const make = makeSelect.value;
      const model = modelSelect.value;
      if (product.universal) return universalToggle.checked || (!year && !make && !model);
      return product.records.some((record) => {
        if (!matchesYear(record, year)) return false;
        if (make && record.make !== make) return false;
        if (model && record.model !== model) return false;
        return true;
      });
    };

    const render = () => {
      const matches = products.filter(productMatches);
      const totalPages = Math.max(1, Math.ceil(matches.length / pageSize));
      currentPage = Math.min(currentPage, totalPages);
      const start = (currentPage - 1) * pageSize;
      const visible = new Set(matches.slice(start, start + pageSize).map((product) => product.card));
      cards.forEach((card) => card.classList.toggle('is-visible', visible.has(card)));
      countElement.textContent = `${matches.length} ${section.dataset.productsFound}`;
      emptyElement.hidden = matches.length > 0;
      previousButton.disabled = currentPage === 1;
      nextButton.disabled = currentPage === totalPages || matches.length === 0;
      pageElement.textContent = `${section.dataset.pageLabel} ${currentPage} / ${totalPages}`;
    };

    const years = new Set();
    specificRecords.forEach((record) => {
      if (!record.start || !record.end) return;
      for (let year = record.start; year <= record.end; year += 1) years.add(year);
    });
    [...years].sort((a, b) => b - a).forEach((year) => yearSelect.add(new Option(String(year), String(year))));

    yearSelect.addEventListener('change', () => {
      updateMakeOptions();
      updateModelOptions();
      currentPage = 1;
      render();
    });
    makeSelect.addEventListener('change', () => {
      updateModelOptions();
      currentPage = 1;
      render();
    });
    modelSelect.addEventListener('change', () => {
      currentPage = 1;
      render();
    });
    universalToggle.addEventListener('change', () => {
      currentPage = 1;
      render();
    });
    resetButton.addEventListener('click', () => {
      yearSelect.value = '';
      makeSelect.value = '';
      modelSelect.value = '';
      universalToggle.checked = true;
      updateMakeOptions();
      updateModelOptions();
      currentPage = 1;
      render();
    });
    previousButton.addEventListener('click', () => {
      currentPage = Math.max(1, currentPage - 1);
      render();
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    nextButton.addEventListener('click', () => {
      currentPage += 1;
      render();
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    render();
  });

  } catch(e) { console.error(e); }
})();
})();
